function updateScrollBar() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}
updateScrollBar();

function updateHeaderBarHeight() {
  const el = document.querySelector('#announcement-bar');

  let height = '0px';

  if (el) {
    const rect = el.getBoundingClientRect();
    const visibleHeight =
      Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

    height = `${Math.max(0, Math.round(visibleHeight))}px`;
  }

  document.documentElement.style.setProperty('--m-ann-bar-height', height);
}
updateHeaderBarHeight();
window.addEventListener('scroll', updateHeaderBarHeight);
window.addEventListener('resize', updateHeaderBarHeight);

function getHeaderHeight() {
  const header = document.querySelector('header');
  if (!header) return;

  const rect = header.getBoundingClientRect();

  document.documentElement.style.setProperty(
    '--m-header-height',
    `${Math.round(rect.height)}px`
  );
  document.documentElement.style.setProperty(
    '--m-header-bottom',
    `${Math.max(0, rect.bottom)}px`
  );
}

getHeaderHeight();
window.addEventListener('scroll', getHeaderHeight);
window.addEventListener('resize', getHeaderHeight);
